export default "__VITE_ASSET__6b535c54__"